console.log('CUSTOM ATC FILE LOADED');

(function () {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.product-card-atc-btn-unique');
    if (!button) return;

    event.preventDefault();
    console.log('CUSTOM ATC BUTTON CLICKED', button);

    const form = button.closest('.product-card-atc-form-unique');
    if (!form) {
      console.error('ATC: No form found for button', button);
      return;
    }

    const variantInput = form.querySelector('[name="id"]');
    if (!variantInput) {
      console.error('ATC: No [name="id"] input/select found in form', form);
      return;
    }

    const variantId = variantInput.value;
    if (!variantId) {
      alert('Please select a scent before adding to cart.');
      variantInput.focus();
      return;
    }

    button.disabled = true;
    button.classList.add('is-loading');

    // Build request body
    const fd = new FormData();
    fd.append('id', variantId);      // keep as STRING
    fd.append('quantity', '1');

    console.log('ATC: Sending /cart/add.js with variant ID:', variantId);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
        // ⚠️ Do NOT set Content-Type manually for FormData
      },
      body: fd,
      credentials: 'same-origin'
    })
      .then((res) => {
        console.log('ATC: /cart/add.js status:', res.status);
        if (!res.ok) {
          return res.text().then((text) => {
            console.error('ATC: Error body:', text);
            throw new Error('Add to cart failed');
          });
        }
        return res.json();
      })
      .then((item) => {
        console.log('ATC: Added to cart successfully:', item);

        // 🔹 Tell Impulse to rebuild cart drawer with fresh cart
        try {
          document.dispatchEvent(new CustomEvent('cart:build'));
          console.log('ATC: Dispatched cart:build');
        } catch (e) {
          console.warn('ATC: Could not dispatch cart:build', e);
        }

        // 🔹 Open the drawer (only if the theme's native drawer is actually active —
        // check the drawer panel itself, not just the header trigger link, since the
        // trigger link exists in the DOM regardless of whether the native drawer is on)
        const nativeDrawerPanel = document.getElementById('CartDrawer');
        if (nativeDrawerPanel) {
          const drawerTrigger = document.querySelector('.js-drawer-open-cart');
          if (drawerTrigger) {
            console.log('ATC: Triggering .js-drawer-open-cart click');
            drawerTrigger.dispatchEvent(new Event('click', { bubbles: true, cancelable: true }));
          } else if (window.theme && typeof theme.CartDrawer === 'function') {
            console.log('ATC: Using theme.CartDrawer fallback');
            if (!window.cartDrawerInstance) {
              window.cartDrawerInstance = new theme.CartDrawer();
              window.cartDrawerInstance.init();
            }
            window.cartDrawerInstance.open();
          } else {
            console.warn('ATC: No cart drawer found – item added but no drawer UI');
          }
        } else {
          // Native drawer is disabled (e.g. cart_type set to "page" so an app like
          // OCU's Slide Cart Drawer owns cart UI instead) — the header cart count
          // bubble still updates via CartWatcher's PerformanceObserver regardless,
          // and the app's own cart UI is expected to handle the rest.
          console.log('ATC: Native cart drawer inactive — deferring to app cart UI / cart count bubble');
        }
      })
      .catch((err) => {
        console.error('ATC: AJAX error:', err);
        alert('Something went wrong adding this product.');
      })
      .finally(() => {
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  });
})();


document.addEventListener('click', function (event) {
    const removeLink = event.target.closest('.cart__remove a');
    if (!removeLink) return; // click wasn't on a remove link
  
    console.log('DRAWER: remove clicked', removeLink);
  
    // Stop the normal navigation to /cart/change
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) {
      event.stopImmediatePropagation();
    }
  
    // Parse the link URL (/cart/change?id=KEY&quantity=0)
    const url = new URL(removeLink.href, window.location.origin);
    const params = new URLSearchParams(url.search);
  
    const id = params.get('id');           // product.key
    let quantity = params.get('quantity'); // usually "0" for remove
  
    if (!id) {
      console.error('DRAWER: remove link missing id param');
      return;
    }
    if (quantity === null) {
      quantity = '0';
    }
  
    const body = new URLSearchParams();
    body.set('id', id);          // same as in href
    body.set('quantity', quantity);
  
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      body: body.toString(),
      credentials: 'same-origin'
    })
      .then((res) => {
        console.log('DRAWER: /cart/change.js status', res.status);
        if (!res.ok) {
          return res.text().then((text) => {
            console.error('DRAWER: error body', text);
            throw new Error('Cart change failed');
          });
        }
        return res.json();
      })
      .then((cart) => {
        console.log('DRAWER: cart updated via AJAX', cart);
  
        // Remove the item row from the drawer DOM
        const itemRow = removeLink.closest('.cart__item');
        if (itemRow) {
          itemRow.remove();
        }
  
        // Optionally ask theme to rebuild drawer / badge etc.
        try {
          document.dispatchEvent(new CustomEvent('cart:build'));
        } catch (e) {
          console.warn('DRAWER: cart:build dispatch failed', e);
        }
      })
      .catch((err) => {
        console.error('DRAWER: AJAX change error', err);
        // Worst-case fallback: let it behave normally
        // window.location.href = removeLink.href;
      });
  });
  
  
  document.addEventListener('click', function (event) {
      const removeLink = event.target.closest('.cart__remove a');
      if (!removeLink) return; // click wasn't on a remove link
    
      console.log('DRAWER: remove clicked', removeLink);
    
      // Stop the normal navigation to /cart/change
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) {
        event.stopImmediatePropagation();
      }
    
      // Parse the link URL (/cart/change?id=KEY&quantity=0)
      const url = new URL(removeLink.href, window.location.origin);
      const params = new URLSearchParams(url.search);
    
      const id = params.get('id');           // product.key
      let quantity = params.get('quantity'); // usually "0" for remove
    
      if (!id) {
        console.error('DRAWER: remove link missing id param');
        return;
      }
      if (quantity === null) {
        quantity = '0';
      }
    
      const body = new URLSearchParams();
      body.set('id', id);          // same as in href
      body.set('quantity', quantity);
    
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: body.toString(),
        credentials: 'same-origin'
      })
        .then((res) => {
          console.log('DRAWER: /cart/change.js status', res.status);
          if (!res.ok) {
            return res.text().then((text) => {
              console.error('DRAWER: error body', text);
              throw new Error('Cart change failed');
            });
          }
          return res.json();
        })
        .then((cart) => {
          console.log('DRAWER: cart updated via AJAX', cart);
    
          // Remove the item row from the drawer DOM
          const itemRow = removeLink.closest('.cart__item');
          if (itemRow) {
            itemRow.remove();
          }
    
          // Optionally ask theme to rebuild drawer / badge etc.
          try {
            document.dispatchEvent(new CustomEvent('cart:build'));
          } catch (e) {
            console.warn('DRAWER: cart:build dispatch failed', e);
          }
        })
        .catch((err) => {
          console.error('DRAWER: AJAX change error', err);
          // Worst-case fallback: let it behave normally
          // window.location.href = removeLink.href;
        });
    });
    